<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Operation Setting Name"
                  v-model="operationSetting.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="operationSetting.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select
                  v-model="operationSetting.operationType"
                  :items="operationTypeList"
                  label="Operation Type..."
                  item-text="label"
                  menu-props="auto"
                  item-value="value"
                  :rules="rules.operationTypeRules"
                ></v-select>
              </v-flex>
              <v-flex sm12 v-if="operationSetting.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="operationSetting.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="operationSetting.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="operationSetting.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="operationSetting.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="operationSetting.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-layout row wrap>
                  <v-flex sm6>
                    <v-switch
                      :label="`Is Auto is ${isAuto ? 'true' : 'false'}`"
                      :value="isAuto"
                      v-model="isAuto"
                    ></v-switch>
                  </v-flex>
                  <v-flex sm6>
                    <v-switch
                      :label="`WIP OS`"
                      v-model="operationSetting.wipOS"
                      :true-value="true"
                      :false-value="false"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <v-layout row wrap>
                  <v-btn color="success" @click="addDebitAccount()">
                    Add Debit Account
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <!-- details table -->
                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="debitDetailCodeSearch"
                        append-icon="search"
                        placeholder="Enter debit code"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="debitDetailHeaders"
                    :items="debitDetailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>
                        <v-text-field
                          placeholder="Enter Debit Code"
                          v-model="props.item.code"
                          @click="
                            showDebitAccountList(), (selectedId = props.item.id)
                          "
                          :rules="rules.codeRules"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.accountName"
                          :loading="showAutocompleteLoading"
                          label="Name"
                          :readonly="true"
                          :rules="rules.nameRules"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-btn
                          icon
                          @click="removeOperationSettingDetail(props.item.id)"
                          :disabled="isDisableDeleteBtn(props.item.id)"
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <v-layout row wrap>
                  <v-btn color="success" @click="addCreditAccount()">
                    Add Credit Account
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <!-- details table -->
                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="creditDetailCodeSearch"
                        append-icon="search"
                        placeholder="Enter credit code"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="creditDetailHeaders"
                    :items="creditDetailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>
                        <v-text-field
                          placeholder="Enter Credit Code"
                          v-model="props.item.code"
                          @click="
                            showCreditAccountList(),
                              (selectedId = props.item.id)
                          "
                          :rules="rules.codeRules"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.accountName"
                          :loading="showAutocompleteLoading"
                          label="Name"
                          :readonly="true"
                          :rules="rules.nameRules"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-btn
                          icon
                          @click="removeOperationSettingDetail(props.item.id)"
                          :disabled="isDisableDeleteBtn(props.item.id)"
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn type="submit" color="primary" :loading="saveLoading">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!--debit account list dialog -->
    <v-dialog
      v-model="showDebitAccountListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <v-layout wrap>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="debitAccountQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accName"
                label="Acccount Name"
                type="text"
                class="mr-1"
                v-model="debitAccountQueryParams.accName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accountheadName"
                label="Account Head Name"
                type="text"
                class="mr-1"
                v-model="debitAccountQueryParams.accountheadName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearchDebitAccount()">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex 12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="accountHeader"
                :items="debitAccountList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalAccountRows"
                :rows-per-page-items="debitRowsPerPageItems"
                :pagination.sync="debitAccountPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setDebitAccount(props.item, selectedId),
                        (showDebitAccountListDialog =
                          !showDebitAccountListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.accName }}</td>
                  <td>{{ props.item.accTypeName }}</td>
                  <td>{{ props.item.nature }}</td>
                  <td>{{ props.item.accounthead.accountName }}</td>
                  <td>{{ props.item.parentCode }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                  <td>
                    <v-icon
                      v-if="props.item.status == 'ACTIVE'"
                      medium
                      color="green"
                      >check_circle</v-icon
                    >
                    <v-icon v-else medium color="red">cancel</v-icon>
                  </td>
                  <td></td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--credit account list dialog -->
    <v-dialog
      v-model="showCreditAccountListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <v-layout wrap>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="creditAccountQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accName"
                label="Acccount Name"
                type="text"
                class="mr-1"
                v-model="creditAccountQueryParams.accName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accountheadName"
                label="Account Head Name"
                type="text"
                class="mr-1"
                v-model="creditAccountQueryParams.accountheadName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearchCreditAccount()">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex 12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="accountHeader"
                :items="creditAccountList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalAccountRows"
                :rows-per-page-items="creditRowsPerPageItems"
                :pagination.sync="creditAccountPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setCreditAccount(props.item, selectedId),
                        (showCreditAccountListDialog =
                          !showCreditAccountListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.accName }}</td>
                  <td>{{ props.item.accTypeName }}</td>
                  <td>{{ props.item.nature }}</td>
                  <td>{{ props.item.accounthead.accountName }}</td>
                  <td>{{ props.item.parentCode }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                  <td>
                    <v-icon
                      v-if="props.item.status == 'ACTIVE'"
                      medium
                      color="green"
                      >check_circle</v-icon
                    >
                    <v-icon v-else medium color="red">cancel</v-icon>
                  </td>
                  <td></td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { chartOfAccountService } from "../../services/chart-of-account-service";
import { OperationSettingFormRules } from "../../helpers/validation-rules";
import { operationSettingService } from "../../services/operation-setting-service";
import { OperationSetting, OperationSettingDetail } from "../../models/model";

export default {
  name: "OperationSettingDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    showDebitAccountListDialog: false,
    showCreditAccountListDialog: false,
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Operation Setting",
        disabled: false,
        to: "operation-settings",
      },
      {
        text: "Operation Setting Details",
        disabled: true,
      },
    ],
    operationTypeList: [],
    createdDate: "",
    updatedDate: "",
    responseError: "",
    saveLoading: false,
    isAuto: false,
    messageDialogBox: false,
    showAutocompleteLoading: false,
    rules: new OperationSettingFormRules(),
    operationSetting: new OperationSetting(),
    operationSettingDetail: new OperationSettingDetail(),
    oldOperationSetting: new OperationSetting(),
    debitAccountQueryParams: {
      accName: "",
      code: "",
      accountheadName: "",
      isParent: false,
    },
    creditAccountQueryParams: {
      accName: "",
      code: "",
      accountheadName: "",
      isParent: false,
    },
    accountHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "accName" },
      { text: "Type", value: "type" },
      { text: "Nature", value: "nature" },
      { text: "Account Head", value: "accountHead.accountName" },
      { text: "Parent Code", value: "accountChild.code" },
      { text: "Updated Date", value: "createdDate" },
      { text: "Updated By", value: "createdBy" },
      { text: "Status", value: "status" },
    ],
    debitAccountPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    creditAccountPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    debitRowsPerPageItems: [25, 50, 100],
    creditRowsPerPageItems: [25, 50, 100],
    totalAccountRows: 0,
    debitAccountList: [],
    creditAccountList: [],

    debitDetailHeaders: [
      { text: "Debit Code", align: "left", value: "code", sortable: false },
      { text: "Debit Account Name", align: "left", sortable: false },
      { text: "Action", value: "action", sortable: false },
    ],
    debitDetailCodeSearch: "",
    creditDetailHeaders: [
      { text: "Credit Code", align: "left", value: "code", sortable: false },
      { text: "Credit Account Name", align: "left", sortable: false },
      { text: "Action", value: "action", sortable: false },
    ],
    creditDetailCodeSearch: "",
  }),

  computed: {
    debitDetailList() {
      return this.operationSetting.operationSettingDetails.filter((d) => {
        if (d.accountType == "DEBIT") {
          if (this.debitDetailCodeSearch)
            return (
              d.code
                .toLowerCase()
                .indexOf(this.debitDetailCodeSearch.toLowerCase()) > -1
            );
          else return true;
        } else return false;
      });
    },
    creditDetailList() {
      return this.operationSetting.operationSettingDetails.filter((d) => {
        if (d.accountType == "CREDIT") {
          if (this.creditDetailCodeSearch)
            return (
              d.code
                .toLowerCase()
                .indexOf(this.creditDetailCodeSearch.toLowerCase()) > -1
            );
          else return true;
        } else return false;
      });
    },
  },

  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new Operation Setting
      this.addDebitAccount();
      this.addCreditAccount();
    } else {
      this.getOperationSettingDetail(id);
    }
    this.getAllOperationSettingType();
  },
  watch: {
    creditAccountPagination: {
      handler() {
        this.getCreditAccountList();
      },
      deep: true,
    },
    debitAccountPagination: {
      handler() {
        this.getDebitAccountList();
      },
      deep: true,
    },
    isAuto() {
      if (this.isAuto == true) {
        if (!this.operationSetting.id) {
          this.operationSetting.operationSettingDetails = [];
          this.addCreditAccount();
          this.addDebitAccount();
        }
      }
    },
  },
  methods: {
    showDebitAccountList() {
      this.debitAccountQueryParams.accName = "";
      this.debitAccountQueryParams.code = "";
      this.debitAccountQueryParams.accountheadName = "";
      this.getDebitAccountList().then(
        (this.showDebitAccountListDialog = !this.showDebitAccountListDialog)
      );
    },

    showCreditAccountList() {
      this.creditAccountQueryParams.accName = "";
      this.creditAccountQueryParams.code = "";
      this.creditAccountQueryParams.accountheadName = "";
      this.getCreditAccountList().then(
        (this.showCreditAccountListDialog = !this.showCreditAccountListDialog)
      );
    },
    getAllOperationSettingType() {
      operationSettingService
        .getOperationSettingTypes()
        .then((res) => {
          if (res.data) {
            this.operationTypeList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDebitAccountList() {
      this.showListLoading = true;
      let order = this.debitAccountPagination.descending ? "desc" : "asc";
      return chartOfAccountService
        .getChartOfAccountList(
          this.debitAccountQueryParams,
          this.debitAccountPagination.page,
          this.debitAccountPagination.rowsPerPage,
          this.debitAccountPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.debitAccountList = res.data.chartOfAccountList;
            this.totalAccountRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getCreditAccountList() {
      this.showListLoading = true;
      let order = this.creditAccountPagination.descending ? "desc" : "asc";
      return chartOfAccountService
        .getChartOfAccountList(
          this.creditAccountQueryParams,
          this.creditAccountPagination.page,
          this.creditAccountPagination.rowsPerPage,
          this.creditAccountPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.creditAccountList = res.data.chartOfAccountList;
            this.totalAccountRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    setDebitAccount(account, id) {
      const index = this.getIndex(id);
      this.operationSetting.operationSettingDetails[index].accountId =
        account.id;
      this.operationSetting.operationSettingDetails[index].code = account.code;
      this.operationSetting.operationSettingDetails[index].accountName =
        account.accName;
    },
    setCreditAccount(account, id) {
      const index = this.getIndex(id);
      this.operationSetting.operationSettingDetails[index].accountId =
        account.id;
      this.operationSetting.operationSettingDetails[index].accountName =
        account.accName;
      this.operationSetting.operationSettingDetails[index].code = account.code;
    },
    onSearchDebitAccount() {
      this.debitAccountPagination.page = this.debitAccountPagination.page;
      this.debitAccountPagination.size =
        this.debitAccountPagination.rowsPerPage;
      this.getDebitAccountList();
    },

    onSearchCreditAccount() {
      this.creditAccountPagination.page = this.creditAccountPagination.page;
      this.creditAccountPagination.size =
        this.creditAccountPagination.rowsPerPage;
      this.getCreditAccountList();
    },

    getIndex(id) {
      return this.operationSetting.operationSettingDetails
        .map((d) => d.id)
        .indexOf(id);
    },

    isDisableDeleteBtn(id) {
      const index = this.getIndex(id);
      return (
        index == 0 ||
        index == 1 ||
        (index == 1 && this.isAuto == true) ||
        (index == 0 && this.isAuto == true)
      );
    },

    getOperationSettingDetail(id) {
      operationSettingService.getOperationSettingDetail(id).then((res) => {
        this.operationSetting = res.data;
        this.isAuto = res.data.auto;
        this.createdDate = commonService.formatDate(
          new Date(this.operationSetting.createdDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.operationSetting.updatedDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.oldOperationSetting = JSON.parse(JSON.stringify(res.data));
      });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.operationSetting.auto = this.isAuto ? "true" : "false";

        this.operationSetting.operationSettingDetails.forEach((detail) => {
          if (detail.isNew) detail.id = null;
        });
        operationSettingService
          .saveOperationSetting(this.operationSetting)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.operationSetting.id) {
        this.operationSetting = new OperationSetting();
        this.isAuto = false;
      } else {
        this.operationSetting = JSON.parse(
          JSON.stringify(this.oldOperationSetting)
        );
        this.isAuto = this.operationSetting.status == "true" ? true : false;
      }
      this.addDebitAccount();
      this.addCreditAccount();
    },

    goBack() {
      this.$router.push("/operation-settings");
    },

    generateId() {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail =
          this.operationSetting.operationSettingDetails.find((d) => d.id == id);
        if (!duplicateDetail) duplicateFlag = false;
      }
      return id;
    },

    addDebitAccount() {
      // deep copy
      let operationSettingDetail = JSON.parse(
        JSON.stringify(this.operationSettingDetail)
      );
      operationSettingDetail.accountType = "DEBIT";

      // if no id, add temporary id for key
      if (!operationSettingDetail.id) {
        operationSettingDetail.isNew = true;
        operationSettingDetail.id = this.generateId();
      }

      this.operationSetting.operationSettingDetails.unshift(
        operationSettingDetail
      );
    },

    addCreditAccount() {
      // deep copy
      let operationSettingDetail = JSON.parse(
        JSON.stringify(this.operationSettingDetail)
      );
      operationSettingDetail.accountType = "CREDIT";

      // if no id, add temporary id for key
      if (!operationSettingDetail.id) {
        operationSettingDetail.isNew = true;
        operationSettingDetail.id = this.generateId();
      }

      this.operationSetting.operationSettingDetails.unshift(
        operationSettingDetail
      );
    },
    removeOperationSettingDetail(operationSettingDetailId) {
      const index = this.getIndex(operationSettingDetailId);

      if (!this.operationSetting.operationSettingDetails[index].isNew) {
        if (!this.operationSetting.deleteOperationSettingDetailIds) {
          this.operationSetting.deleteOperationSettingDetailIds = [];
        }
        this.operationSetting.deleteOperationSettingDetailIds.push(
          operationSettingDetailId
        );
      }
      this.$delete(this.operationSetting.operationSettingDetails, index);
    },
  },
};
</script>
